/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IntraOPCount from './intra-op-count';
import IntraOPCountDetail from './intra-op-count-detail';
import IntraOPCountUpdate from './intra-op-count-update';
import IntraOPCountDeleteDialog from './intra-op-count-delete-dialog';

const IntraOPCountRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IntraOPCount />} />
    <Route path="new" element={<IntraOPCountUpdate />} />
    <Route path=":id">
      <Route index element={<IntraOPCountDetail />} />
      <Route path="edit" element={<IntraOPCountUpdate />} />
      <Route path="delete" element={<IntraOPCountDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IntraOPCountRoutes;
